let scriptsAppened = false

export default function appendAdditionalScripts (scripts) {
  if (scriptsAppened) return
  scriptsAppened = true

  const range = document.createRange()

  // append to head
  if (scripts.hasOwnProperty('head')) {
    const head = document.getElementsByTagName('head')[ 0 ]

    try {
      range.setStart(head)
    } catch (err) {
      range.setStart(head, 0) // - didn't work for moderately old iOS
    }

    head.appendChild(
      range.createContextualFragment(scripts.head)
    )
  }

  // append to body
  range.selectNode(document.body)
  if (scripts.hasOwnProperty('body')) {
    const body = document.body
    body.appendChild(
      range.createContextualFragment(scripts.body)
    )
  }
}
